import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 2560.000000 2560.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,2560.000000) scale(0.100000,-0.100000)">

<path d="M12635 22148 c-27 -5 -81 -13 -120 -18 -110 -15 -167 -25 -205 -37
-19 -7 -55 -17 -80 -23 -25 -6 -59 -16 -76 -21 -17 -5 -38 -9 -46 -9 -9 0 -31
-8 -50 -17 -60 -30 -68 -33 -83 -33 -8 0 -23 -4 -33 -9 -9 -5 -44 -21 -77 -36
-87 -39 -123 -57 -190 -95 -33 -18 -76 -42 -95 -53 -19 -10 -65 -41 -102 -68
-37 -27 -70 -49 -73 -49 -5 0 -7 -1 -110 -86 -68 -55 -229 -213 -290 -284 -41
-47 -118 -157 -139 -197 -35 -69 -12 -185 46 -239 51 -47 96 -64 169 -64 108
0 141 22 245 160 50 67 182 204 269 279 43 38 79 65 143 106 9 6 24 17 33 25
10 8 39 26 66 40 26 14 50 27 53 31 16 17 241 118 310 138 25 7 52 16 60 19
122 45 236 65 484 87 151 13 187 13 330 -1 192 -18 322 -38 361 -54 39 -16
124 -40 144 -40 12 0 21 -4 21 -10 0 -5 7 -10 15 -10 8 0 29 -6 47 -14 18 -8
51 -22 73 -31 291 -123 555 -331 770 -606 58 -75 69 -84 114 -104 44 -19 159
-20 197 0 44 22 79 56 105 100 18 32 23 54 22 105 0 36 -7 77 -15 91 -18 34
-76 114 -105 146 -13 13 -23 26 -23 29 0 14 -187 204 -260 264 -30 25 -64 53
-75 63 -35 32 -208 153 -255 178 -25 13 -47 26 -50 29 -3 3 -32 20 -65 36 -33
17 -69 35 -80 41 -11 6 -31 15 -45 21 -14 6 -51 22 -82 36 -31 14 -64 26 -72
26 -8 0 -18 5 -21 10 -3 6 -14 10 -23 10 -9 0 -30 7 -46 15 -15 8 -39 15 -52
15 -12 0 -26 5 -29 10 -3 6 -19 10 -35 10 -16 0 -32 5 -35 10 -3 6 -20 10 -36
10 -17 0 -39 5 -49 10 -19 10 -92 24 -210 40 -36 5 -90 13 -120 19 -68 12
-457 12 -525 -1z"/>
<path d="M12665 21470 c-33 -4 -88 -11 -122 -15 -35 -4 -63 -12 -63 -16 0 -5
-17 -9 -38 -9 -21 0 -42 -4 -47 -8 -6 -5 -39 -17 -75 -27 -36 -10 -69 -22 -74
-27 -6 -4 -20 -8 -32 -8 -13 0 -25 -4 -28 -9 -3 -4 -27 -16 -53 -26 -26 -10
-50 -21 -53 -24 -3 -3 -34 -21 -70 -38 -121 -61 -182 -102 -318 -215 -78 -66
-210 -206 -256 -274 -132 -195 -146 -223 -146 -296 0 -47 6 -71 25 -104 51
-86 159 -134 253 -113 60 14 133 65 156 110 44 84 62 110 157 219 276 315 715
481 1159 437 74 -8 207 -33 245 -47 11 -4 38 -13 60 -19 285 -86 558 -300 709
-557 46 -79 93 -120 162 -140 110 -32 220 19 275 128 46 91 11 195 -131 383
-170 226 -374 392 -640 523 -70 34 -131 62 -138 62 -7 0 -20 4 -30 10 -25 13
-167 55 -237 69 -33 7 -78 17 -100 23 -51 12 -471 19 -550 8z"/>
<path d="M12738 20703 c-54 -2 -98 -8 -98 -13 0 -6 -18 -10 -40 -10 -21 0 -49
-4 -62 -9 -13 -5 -50 -17 -83 -26 -33 -9 -69 -21 -80 -25 -94 -38 -214 -96
-236 -116 -8 -8 -21 -14 -27 -14 -6 0 -17 -6 -24 -13 -7 -7 -29 -24 -48 -37
-19 -14 -44 -32 -55 -40 -27 -20 -194 -188 -223 -223 -39 -48 -92 -135 -92
-151 0 -8 -4 -18 -10 -21 -16 -10 -11 -70 9 -118 39 -90 136 -157 228 -157 68
0 141 40 181 97 165 242 395 383 693 424 85 12 203 8 309 -10 264 -44 474
-178 627 -401 94 -135 258 -146 376 -24 52 54 69 118 51 186 -7 29 -22 64 -34
80 -11 15 -20 30 -20 33 0 11 -121 152 -172 200 -97 92 -318 245 -353 245 -7
0 -17 6 -23 13 -6 7 -34 19 -62 27 -28 8 -53 18 -56 22 -3 4 -16 8 -29 8 -13
0 -27 5 -30 10 -3 6 -18 10 -33 10 -15 1 -38 7 -52 15 -14 8 -40 14 -58 15
-18 0 -41 4 -50 9 -20 10 -286 19 -424 14z"/>
<path d="M10125 20674 c-21 -8 -42 -18 -45 -23 -3 -4 -27 -13 -55 -20 -62 -15
-105 -31 -105 -41 0 -4 -26 -13 -57 -19 -32 -7 -65 -19 -73 -26 -8 -7 -38 -20
-67 -28 -29 -9 -69 -27 -90 -41 -21 -14 -44 -26 -52 -26 -13 0 -48 -15 -186
-80 -33 -16 -77 -34 -97 -40 -21 -6 -40 -16 -44 -21 -3 -5 -31 -22 -62 -38
-120 -59 -146 -74 -160 -87 -7 -8 -25 -17 -38 -20 -29 -7 -327 -183 -362 -214
-13 -11 -29 -20 -36 -20 -7 0 -24 -9 -37 -21 -13 -11 -37 -28 -54 -36 -16 -9
-41 -24 -55 -35 -43 -33 -94 -66 -127 -84 -18 -9 -33 -20 -33 -25 0 -5 -12
-15 -27 -23 -16 -8 -38 -22 -50 -33 -11 -10 -47 -36 -78 -58 -52 -37 -151
-112 -200 -153 -11 -10 -33 -27 -50 -40 -47 -36 -93 -74 -133 -110 -20 -18
-44 -39 -52 -47 -8 -7 -33 -27 -55 -45 -39 -30 -371 -346 -468 -445 -94 -96
-222 -238 -267 -296 -14 -17 -40 -48 -57 -68 -66 -73 -73 -82 -88 -112 -10
-19 -14 -41 -10 -60 5 -21 197 -219 725 -746 395 -395 723 -722 729 -728 6 -5
207 -207 447 -449 401 -403 435 -440 429 -465 -4 -14 -15 -35 -26 -47 -10 -11
-19 -25 -19 -31 0 -6 -11 -24 -24 -40 -14 -16 -32 -48 -41 -71 -10 -23 -21
-42 -25 -42 -4 0 -15 -21 -25 -47 -10 -27 -24 -52 -30 -58 -6 -5 -20 -30 -30
-55 -10 -25 -24 -52 -30 -60 -7 -8 -20 -35 -29 -60 -10 -25 -22 -50 -26 -55
-5 -6 -21 -44 -36 -85 -14 -41 -30 -77 -34 -80 -4 -3 -12 -27 -19 -53 -6 -27
-20 -68 -30 -90 -29 -70 -62 -168 -83 -252 -11 -44 -26 -93 -33 -110 -7 -16
-20 -75 -29 -130 -9 -55 -24 -134 -35 -175 -11 -41 -24 -147 -31 -235 -6 -88
-16 -185 -22 -215 -18 -87 -15 -462 5 -615 9 -71 21 -179 26 -240 5 -60 16
-139 25 -175 9 -36 24 -114 35 -173 11 -59 24 -113 29 -120 5 -7 13 -32 17
-57 7 -46 91 -307 105 -325 4 -5 13 -32 20 -59 8 -28 24 -70 37 -95 13 -26 23
-53 23 -62 0 -9 10 -31 23 -50 12 -19 28 -52 36 -74 7 -22 19 -47 26 -55 8 -8
21 -35 31 -60 9 -25 22 -51 27 -58 6 -7 21 -34 34 -60 42 -83 82 -154 96 -171
7 -9 33 -47 56 -86 46 -75 81 -128 106 -160 9 -11 25 -33 35 -50 41 -62 71
-99 90 -112 11 -8 20 -20 20 -26 0 -7 25 -38 55 -70 30 -32 55 -60 55 -63 0
-7 60 -73 162 -179 47 -49 95 -99 105 -110 21 -22 151 -139 191 -170 14 -11
43 -35 66 -52 23 -18 49 -40 58 -49 10 -10 28 -24 42 -33 13 -9 51 -37 84 -63
33 -25 70 -52 83 -59 13 -7 30 -20 37 -31 7 -10 22 -18 33 -18 10 0 19 -4 19
-8 0 -4 26 -23 58 -42 31 -18 64 -39 72 -46 8 -6 55 -33 105 -59 49 -26 102
-56 117 -66 14 -10 33 -19 41 -19 8 0 25 -8 38 -19 13 -10 35 -22 49 -26 14
-4 52 -20 85 -35 33 -15 85 -39 115 -53 30 -14 79 -32 109 -41 30 -9 64 -22
76 -30 11 -7 47 -19 80 -27 33 -7 69 -18 80 -25 11 -7 60 -22 108 -33 48 -12
96 -25 105 -30 10 -5 62 -17 116 -26 55 -9 117 -23 140 -31 41 -15 147 -28
346 -44 63 -5 133 -14 155 -20 26 -6 603 -10 1632 -10 1099 0 1600 -3 1620
-11 32 -12 107 -84 355 -339 37 -38 76 -74 87 -80 38 -20 16 -100 -27 -100 -6
0 -16 -9 -22 -20 -6 -11 -16 -20 -22 -20 -6 0 -27 -12 -46 -27 -20 -16 -48
-35 -63 -43 -50 -28 -144 -93 -147 -101 -2 -5 -11 -9 -19 -9 -9 0 -30 -11 -47
-24 -17 -13 -51 -34 -75 -47 -23 -13 -64 -36 -90 -51 -25 -15 -71 -40 -101
-55 -30 -16 -71 -38 -90 -48 -19 -10 -44 -23 -55 -28 -11 -6 -31 -16 -45 -23
-58 -30 -180 -84 -189 -84 -4 0 -19 -8 -32 -18 -13 -10 -50 -26 -81 -35 -32
-10 -58 -21 -58 -25 0 -5 -26 -16 -57 -26 -32 -10 -72 -24 -90 -32 -18 -7 -60
-20 -94 -29 -34 -9 -72 -23 -85 -31 -12 -9 -44 -22 -71 -29 -26 -8 -73 -22
-103 -33 -30 -11 -84 -25 -120 -32 -36 -6 -74 -17 -85 -25 -12 -7 -52 -18 -90
-24 -39 -6 -95 -18 -125 -27 -30 -9 -100 -22 -155 -30 -55 -8 -127 -22 -160
-30 -33 -9 -141 -24 -240 -34 -99 -10 -214 -25 -255 -32 -53 -9 -192 -13 -470
-13 -278 0 -417 4 -470 13 -41 7 -158 22 -259 32 -101 11 -198 24 -215 30 -17
5 -87 18 -156 29 -69 11 -150 27 -180 35 -30 9 -86 21 -125 27 -38 6 -80 17
-91 24 -12 8 -50 19 -85 25 -35 7 -89 21 -119 32 -30 11 -75 25 -100 32 -25 7
-59 20 -75 28 -17 9 -57 24 -90 33 -33 9 -73 22 -90 30 -16 7 -56 20 -87 30
-32 9 -58 20 -58 24 0 4 -26 16 -57 27 -32 10 -69 26 -82 36 -13 10 -29 18
-35 18 -6 0 -38 13 -71 29 -33 16 -76 37 -95 45 -19 8 -46 21 -60 29 -14 8
-41 22 -60 31 -43 21 -140 73 -200 109 -25 15 -65 36 -89 48 -25 12 -54 30
-65 40 -11 10 -29 22 -40 25 -12 4 -23 10 -26 14 -3 4 -28 23 -57 41 -188 124
-290 195 -301 211 -7 10 -18 18 -24 18 -15 0 -182 128 -244 187 -27 26 -70 64
-94 83 -25 19 -59 49 -76 65 -17 17 -73 68 -124 115 -51 47 -102 95 -114 108
-12 13 -54 58 -94 100 -40 42 -88 95 -106 117 -18 22 -46 54 -62 72 -27 29
-44 49 -129 150 -16 19 -40 47 -52 61 -13 14 -23 28 -23 32 0 3 -8 15 -18 26
-10 10 -33 42 -52 69 -41 60 -41 61 -80 106 -16 20 -30 40 -30 44 0 5 -12 24
-27 44 -55 70 -72 97 -94 135 -11 21 -29 48 -40 59 -10 12 -19 26 -19 33 0 7
-6 19 -14 26 -8 8 -27 38 -42 67 -16 29 -39 70 -51 92 -12 22 -30 52 -40 67
-10 15 -26 43 -35 62 -10 19 -36 69 -58 110 -22 41 -45 91 -51 110 -6 19 -18
42 -25 50 -7 9 -20 36 -29 60 -8 25 -24 63 -34 85 -79 164 -105 230 -142 360
-11 39 -28 88 -39 110 -22 47 -65 186 -81 265 -6 30 -17 65 -25 77 -8 12 -21
65 -29 117 -8 52 -22 113 -30 135 -8 23 -19 81 -26 129 -6 48 -20 124 -30 170
-11 46 -24 138 -29 205 -6 67 -18 178 -28 247 -25 179 -25 815 0 1010 10 74
22 191 28 260 6 69 18 151 26 182 8 32 21 104 29 160 8 57 24 131 34 164 11
34 23 90 27 125 4 35 14 77 22 94 8 16 23 68 33 114 10 46 23 89 28 95 5 6 14
38 21 71 7 33 21 74 31 90 9 17 21 47 24 68 7 38 7 39 -79 122 -47 46 -86 88
-86 94 0 5 -8 13 -17 16 -10 4 -36 28 -58 55 -22 26 -49 53 -61 60 -11 6 -28
25 -38 41 -9 16 -24 29 -32 29 -8 0 -14 4 -14 8 0 9 -17 27 -81 89 -24 23 -49
48 -55 55 -6 7 -20 21 -30 30 -11 9 -24 23 -30 30 -6 7 -20 20 -30 29 -11 9
-50 48 -87 88 -37 39 -70 71 -73 71 -7 0 -34 27 -34 34 0 3 -32 36 -71 73 -39
37 -92 90 -118 116 -25 27 -52 54 -59 60 -71 66 -152 150 -152 157 0 18 -49
41 -82 38 -29 -3 -34 -8 -50 -53 -10 -27 -28 -72 -42 -100 -61 -128 -84 -182
-91 -212 -3 -18 -10 -33 -15 -33 -9 0 -40 -84 -40 -108 0 -8 -8 -26 -18 -40
-10 -15 -25 -49 -32 -77 -7 -27 -21 -66 -30 -85 -10 -19 -25 -64 -34 -99 -9
-36 -21 -70 -26 -76 -6 -7 -19 -43 -29 -81 -64 -230 -80 -282 -89 -304 -6 -14
-19 -65 -27 -115 -9 -49 -20 -94 -25 -100 -4 -5 -15 -55 -25 -110 -9 -55 -25
-136 -36 -180 -10 -44 -23 -114 -29 -155 -6 -41 -19 -122 -30 -180 -11 -58
-29 -208 -40 -335 -12 -126 -26 -270 -31 -320 -16 -142 -6 -944 14 -1085 9
-63 23 -192 32 -286 8 -94 20 -186 26 -205 5 -19 16 -86 25 -149 8 -63 22
-142 30 -175 9 -33 25 -109 35 -170 11 -60 26 -128 34 -150 8 -22 19 -67 25
-100 6 -33 17 -76 25 -95 8 -19 24 -75 35 -123 11 -49 26 -100 34 -115 7 -15
17 -47 21 -72 4 -25 13 -55 21 -67 8 -13 22 -51 30 -85 9 -35 25 -79 35 -99
10 -20 23 -58 30 -85 7 -27 19 -60 29 -74 9 -14 22 -50 29 -80 8 -30 22 -67
32 -82 11 -14 19 -31 19 -38 0 -6 17 -48 39 -93 42 -90 91 -210 91 -225 0 -5
9 -17 20 -27 11 -10 25 -35 30 -56 6 -21 17 -45 26 -53 8 -8 21 -34 30 -58 8
-24 25 -59 38 -78 13 -19 27 -46 31 -60 4 -14 13 -32 20 -40 7 -8 22 -33 33
-55 35 -70 73 -138 106 -191 17 -28 46 -77 64 -108 19 -31 38 -56 43 -56 5 0
9 -8 9 -17 0 -10 16 -38 35 -62 19 -24 35 -47 35 -51 0 -4 11 -20 25 -36 14
-16 25 -34 25 -39 0 -6 14 -23 30 -38 17 -16 30 -35 30 -42 0 -8 13 -30 30
-48 16 -19 30 -42 30 -51 0 -9 4 -16 8 -16 4 0 15 -13 24 -28 9 -15 30 -43 47
-62 17 -19 31 -38 31 -41 0 -11 42 -63 266 -329 240 -285 281 -329 555 -592
110 -105 164 -155 249 -228 41 -35 86 -74 100 -86 108 -96 266 -223 324 -259
17 -10 37 -27 44 -37 7 -10 19 -18 26 -18 7 0 30 -15 52 -33 44 -36 60 -47
194 -138 113 -76 119 -80 188 -120 28 -17 52 -34 52 -38 0 -3 23 -16 50 -29
28 -13 50 -27 50 -32 0 -6 4 -10 10 -10 5 0 31 -13 57 -29 97 -59 139 -82 186
-103 26 -11 47 -24 47 -28 0 -4 19 -15 42 -25 23 -9 53 -24 67 -34 14 -10 37
-22 51 -26 14 -4 39 -17 55 -29 17 -12 49 -28 73 -35 23 -6 59 -23 79 -36 20
-14 42 -25 50 -25 7 0 36 -11 63 -25 27 -14 55 -25 62 -25 7 0 33 -14 57 -30
24 -17 54 -30 66 -30 12 0 43 -11 69 -25 26 -14 68 -30 93 -36 25 -5 58 -18
72 -28 14 -10 52 -24 84 -31 31 -7 57 -16 57 -20 0 -9 91 -40 117 -40 10 0 35
-9 56 -19 20 -10 49 -22 64 -25 26 -6 103 -29 303 -92 41 -12 107 -28 145 -34
39 -6 82 -17 97 -25 15 -7 47 -16 70 -20 167 -25 238 -38 273 -50 22 -7 87
-18 145 -24 58 -7 141 -21 184 -32 44 -10 103 -19 131 -19 28 0 123 -9 211
-19 226 -28 365 -34 734 -34 365 0 484 6 714 34 88 10 183 19 211 19 28 0 87
9 131 19 43 11 124 25 179 31 55 7 143 22 195 35 52 13 124 27 160 30 36 4 85
15 110 25 25 10 79 23 120 30 41 7 86 17 100 23 14 5 70 22 125 38 211 58 251
71 286 90 20 10 47 19 60 19 28 0 91 21 110 36 8 6 36 16 63 23 27 7 69 23 95
36 25 14 55 25 66 25 11 0 47 14 80 30 33 16 69 30 80 30 11 0 40 14 65 30 25
16 51 30 58 30 7 0 35 11 62 25 27 14 56 25 63 25 8 0 30 11 49 24 20 13 52
29 72 36 37 12 126 57 240 122 33 18 102 56 155 84 53 28 115 62 138 77 24 15
47 27 53 27 5 0 10 4 10 10 0 5 23 19 50 32 28 13 50 26 50 29 0 4 25 22 56
41 85 50 82 48 193 123 117 79 131 89 232 165 41 30 81 60 90 65 50 31 363
289 436 359 11 12 46 43 77 70 49 43 147 137 361 345 50 49 103 105 215 231 8
9 35 41 59 71 24 30 53 63 63 74 52 58 97 117 103 135 4 12 1 35 -6 52 -12 30
-333 358 -350 358 -5 0 -9 5 -9 11 0 11 -138 149 -149 149 -4 0 -14 13 -23 28
-9 15 -28 34 -42 42 -14 7 -26 17 -26 22 0 12 -379 388 -391 388 -5 0 -9 4 -9
10 0 9 -309 320 -436 441 -27 25 -78 78 -114 117 -36 39 -71 72 -77 72 -7 0
-13 5 -13 12 0 12 -218 228 -232 228 -4 0 -8 4 -8 10 0 5 -54 63 -120 129 -66
65 -120 124 -120 129 0 29 -110 31 -1983 31 -1831 1 -1902 1 -2020 20 -67 11
-152 22 -189 25 -36 4 -83 13 -102 21 -20 9 -69 22 -109 30 -39 9 -88 24 -107
34 -20 10 -51 22 -70 26 -19 4 -55 18 -80 31 -73 37 -199 94 -210 94 -5 0 -10
4 -10 8 0 5 -24 19 -52 33 -29 13 -55 28 -56 32 -2 4 -25 19 -50 33 -26 13
-63 37 -83 52 -20 15 -70 52 -111 83 -41 32 -87 68 -101 80 -14 13 -44 40 -66
59 -74 63 -193 189 -226 240 -13 19 -35 47 -49 62 -14 15 -26 30 -26 32 0 3
-21 34 -47 68 -53 68 -78 107 -119 182 -14 27 -32 56 -40 64 -8 7 -14 19 -14
26 0 7 -12 35 -26 62 -14 26 -33 69 -41 94 -8 25 -18 47 -22 50 -10 8 -31 59
-31 77 0 9 -9 35 -19 57 -11 23 -29 79 -41 126 -11 47 -27 99 -34 115 -8 17
-17 66 -21 110 -4 44 -14 114 -22 155 -8 41 -17 152 -20 245 -5 140 -2 195 15
315 12 80 24 170 28 200 3 30 14 78 24 105 10 28 23 77 30 110 7 33 18 74 25
90 7 17 21 55 30 85 10 30 23 66 30 80 7 14 17 36 23 50 50 122 133 274 227
416 41 62 142 188 193 241 28 30 52 58 52 61 0 19 225 221 306 275 26 18 58
39 71 48 13 9 33 26 44 38 11 11 27 21 35 21 8 0 25 9 36 20 12 11 44 30 70
42 26 12 48 25 48 30 0 4 7 8 15 8 8 0 15 5 15 10 0 6 8 10 18 10 9 0 40 14
67 30 28 16 59 30 70 30 11 0 38 11 60 25 22 13 48 25 57 25 10 0 43 11 75 25
31 14 91 33 132 41 42 9 87 22 101 29 14 7 66 18 115 25 50 6 135 19 190 28
68 11 157 17 275 17 118 0 207 -6 275 -17 55 -9 141 -22 190 -29 50 -7 102
-18 116 -25 14 -7 63 -20 110 -30 46 -9 89 -20 95 -25 10 -8 54 -26 194 -78
25 -10 68 -29 97 -44 29 -15 59 -27 68 -27 8 0 15 -4 15 -9 0 -5 29 -24 65
-42 36 -18 74 -41 84 -51 11 -10 27 -18 35 -18 8 0 23 -9 33 -19 20 -21 56
-49 138 -104 47 -32 73 -54 167 -142 21 -19 42 -35 48 -35 5 0 10 -6 10 -13 0
-7 14 -23 30 -35 17 -13 30 -27 30 -32 0 -4 21 -30 48 -57 26 -26 54 -58 62
-70 8 -11 50 -67 93 -122 42 -56 77 -104 77 -107 0 -3 13 -24 28 -47 16 -23
38 -60 49 -82 11 -22 38 -74 59 -115 22 -41 46 -94 53 -118 8 -23 20 -47 28
-53 17 -15 17 -53 -1 -68 -10 -8 -266 -11 -961 -11 -848 1 -951 3 -979 17 -29
15 -161 137 -250 232 -22 24 -47 49 -54 55 -8 6 -35 33 -60 60 -26 26 -55 56
-66 65 -10 9 -24 22 -30 29 -6 7 -30 31 -54 55 -24 23 -51 50 -60 61 -9 10
-23 24 -30 30 -7 6 -38 37 -70 69 -65 66 -88 70 -182 37 -30 -11 -81 -29 -114
-41 -32 -11 -65 -26 -73 -34 -8 -8 -32 -19 -53 -25 -22 -6 -42 -15 -45 -20 -4
-6 -25 -20 -48 -32 -35 -17 -87 -54 -175 -123 -7 -5 -25 -22 -39 -37 -15 -16
-29 -28 -33 -28 -9 0 -137 -126 -175 -171 -82 -99 -130 -165 -148 -204 -8 -16
-26 -47 -40 -68 -14 -21 -28 -51 -32 -67 -4 -17 -11 -30 -16 -30 -4 0 -16 -25
-25 -56 -9 -31 -27 -80 -40 -108 -15 -31 -24 -70 -24 -99 l0 -48 508 -507
c280 -279 519 -514 530 -522 12 -8 22 -19 22 -25 1 -11 40 -34 175 -99 61 -30
116 -48 170 -57 64 -10 499 -14 2157 -16 l2077 -3 25 30 c14 17 28 47 31 68 3
20 10 51 15 67 5 17 11 89 15 160 3 72 13 168 22 215 19 102 22 528 4 600 -6
25 -15 119 -21 210 -8 109 -20 197 -36 260 -13 52 -28 127 -34 165 -6 39 -19
97 -30 130 -10 33 -25 87 -33 120 -16 65 -51 167 -78 230 -9 23 -22 60 -29 84
-6 23 -19 57 -29 74 -9 18 -23 54 -31 80 -7 26 -21 58 -30 70 -9 12 -23 40
-30 62 -7 22 -18 47 -24 55 -7 8 -21 35 -31 60 -10 25 -24 50 -30 55 -6 6 -19
30 -29 55 -10 25 -21 47 -26 50 -4 3 -19 28 -34 55 -59 110 -227 364 -278 419
-10 11 -18 24 -18 29 0 5 -11 18 -25 29 -14 11 -25 24 -25 30 0 29 -353 401
-510 538 -41 36 -76 68 -78 73 -2 4 -8 7 -12 7 -5 0 -20 10 -34 23 -49 44 -94
77 -104 77 -6 0 -17 8 -24 18 -7 10 -42 38 -78 62 -36 25 -79 56 -96 70 -17
14 -44 32 -60 41 -16 9 -81 48 -145 87 -64 39 -128 74 -143 78 -14 3 -26 9
-26 13 0 7 -161 91 -175 91 -4 0 -33 13 -64 28 -31 16 -74 35 -96 42 -22 7
-47 18 -55 25 -8 7 -47 23 -87 34 -40 12 -75 26 -78 31 -3 5 -31 14 -63 20
-31 7 -76 21 -100 31 -23 11 -68 24 -99 30 -31 6 -77 19 -102 29 -25 10 -85
23 -133 29 -48 6 -102 18 -121 26 -37 15 -270 45 -357 45 -30 0 -82 7 -115 15
-73 17 -550 21 -605 5 -19 -6 -93 -15 -165 -20 -169 -13 -281 -28 -326 -45
-20 -8 -77 -19 -125 -26 -49 -6 -110 -19 -135 -29 -25 -10 -71 -23 -102 -29
-31 -6 -76 -19 -99 -30 -24 -10 -69 -24 -100 -31 -32 -6 -60 -15 -63 -20 -3
-5 -38 -19 -78 -31 -40 -12 -88 -30 -107 -40 -64 -33 -190 -89 -201 -89 -6 0
-23 -8 -37 -19 -15 -10 -43 -23 -63 -30 -20 -6 -44 -19 -55 -29 -10 -10 -35
-24 -54 -32 -19 -7 -47 -22 -62 -32 -14 -10 -29 -18 -32 -18 -3 0 -33 -18 -67
-40 -34 -22 -68 -40 -74 -40 -7 0 -18 -7 -25 -15 -20 -24 -38 -18 -89 33 -27
26 -57 55 -67 64 -11 9 -52 49 -91 90 -40 40 -79 78 -85 85 -7 6 -48 48 -91
92 -43 45 -81 81 -86 81 -4 0 -13 11 -19 24 -6 13 -20 27 -31 31 -12 3 -21 11
-21 16 0 11 -161 169 -172 169 -5 0 -8 6 -8 13 0 8 -11 20 -25 27 -14 7 -25
17 -25 22 0 5 -21 28 -47 51 -26 23 -67 64 -92 90 -55 58 -184 187 -206 205
-30 25 -18 58 36 101 29 23 57 41 63 41 6 1 27 14 46 30 19 17 39 30 46 30 6
0 19 9 30 21 10 12 35 30 54 40 52 29 134 80 140 88 5 6 41 26 139 78 25 13
52 29 60 36 9 7 40 24 69 37 28 13 52 27 52 32 0 4 8 8 18 8 10 0 39 13 64 29
25 16 56 32 68 36 13 4 49 20 79 36 31 16 63 29 71 29 9 0 31 11 50 25 19 14
41 25 50 25 10 0 37 10 61 23 24 13 94 40 154 60 245 83 387 134 396 144 4 4
-18 35 -48 68 -30 33 -84 96 -120 140 -63 79 -203 278 -203 289 0 4 -12 25
-26 47 -37 60 -119 225 -152 310 -80 204 -122 351 -156 554 -24 145 -26 147
-101 119z"/>
<path d="M15294 20566 c-2 -6 -13 -58 -24 -116 -55 -291 -181 -596 -359 -875
-80 -124 -108 -163 -186 -254 -75 -88 -94 -110 -164 -179 -84 -84 -85 -80 22
-112 97 -29 198 -66 242 -89 21 -12 47 -21 56 -21 9 0 28 -9 42 -20 14 -12 41
-26 59 -32 34 -11 148 -61 183 -81 36 -20 118 -64 220 -117 55 -29 111 -60
125 -69 14 -9 39 -23 55 -31 17 -8 32 -18 35 -21 3 -3 43 -30 90 -59 47 -29
93 -59 103 -68 9 -8 25 -20 35 -26 33 -20 117 -75 128 -84 5 -5 20 -15 32 -21
12 -6 32 -21 46 -34 27 -25 97 -75 132 -95 13 -7 29 -22 34 -33 6 -10 16 -19
23 -19 7 0 40 -26 73 -58 34 -31 81 -73 105 -92 63 -51 193 -171 202 -186 4
-8 12 -14 17 -14 11 0 79 -67 155 -152 75 -83 83 -92 95 -103 11 -10 45 -49
120 -136 25 -28 55 -61 68 -72 12 -11 22 -25 22 -30 0 -5 12 -21 28 -36 23
-24 91 -112 142 -185 8 -11 36 -49 62 -83 27 -34 48 -66 48 -69 0 -4 12 -23
28 -43 54 -71 72 -97 93 -136 12 -22 25 -42 29 -45 5 -3 19 -24 32 -47 62
-111 82 -143 89 -143 4 0 13 -17 20 -37 6 -21 21 -51 33 -68 11 -16 29 -46 39
-65 9 -19 40 -78 67 -130 27 -52 50 -101 50 -108 0 -8 9 -25 20 -39 11 -14 25
-44 31 -67 6 -22 14 -43 18 -46 11 -9 31 -49 31 -63 0 -7 11 -35 24 -63 31
-62 73 -172 92 -244 9 -30 26 -80 39 -110 31 -74 53 -142 72 -220 8 -36 22
-85 30 -110 48 -145 137 -592 154 -770 6 -63 20 -169 31 -235 18 -107 20 -164
20 -535 0 -370 -2 -427 -20 -525 -11 -60 -25 -172 -31 -249 -7 -76 -20 -171
-30 -210 -11 -39 -24 -108 -30 -153 -6 -45 -20 -109 -31 -142 -11 -33 -20 -72
-20 -86 0 -32 -20 -116 -31 -131 -5 -5 -18 -50 -29 -100 -11 -49 -24 -98 -30
-109 -24 -52 -70 -206 -70 -235 0 -25 10 -43 48 -81 26 -26 52 -52 57 -58 25
-25 55 -55 124 -123 96 -95 152 -152 172 -175 9 -10 36 -37 60 -60 24 -24 49
-47 54 -53 6 -6 71 -71 145 -145 74 -74 154 -154 177 -177 23 -24 104 -104
180 -179 76 -75 157 -157 180 -183 38 -43 45 -47 80 -44 37 3 39 5 58 63 18
55 73 172 93 199 5 6 14 31 21 56 7 25 21 60 32 78 10 18 24 54 31 80 6 26 19
61 29 77 10 17 23 50 29 75 7 25 19 58 27 74 8 16 24 61 35 100 11 39 23 75
28 81 5 6 15 36 21 66 6 30 17 65 24 79 7 14 23 68 35 120 13 52 27 103 32
114 6 10 19 61 29 113 11 52 24 102 29 111 10 20 40 172 40 206 0 13 7 39 15
58 8 20 21 89 30 154 9 66 22 146 30 179 7 33 18 107 24 165 22 208 43 427 51
530 11 138 11 822 0 925 -5 44 -13 121 -19 170 -5 50 -15 149 -21 220 -6 72
-18 168 -26 215 -9 47 -22 130 -30 185 -8 55 -21 127 -30 160 -8 33 -24 111
-35 174 -11 63 -24 122 -29 131 -5 9 -18 62 -29 118 -11 56 -25 109 -30 119
-5 10 -19 58 -31 108 -12 49 -25 94 -29 100 -5 5 -14 35 -21 65 -7 30 -18 69
-26 85 -15 33 -66 180 -92 266 -9 30 -24 66 -33 80 -9 13 -19 39 -22 58 -4 19
-23 67 -42 107 -19 40 -35 78 -35 86 0 7 -9 24 -20 38 -11 14 -20 31 -20 38 0
19 -80 203 -101 234 -11 14 -19 33 -19 41 0 8 -11 30 -24 50 -13 19 -27 46
-31 58 -6 20 -95 191 -138 264 -6 11 -24 44 -39 73 -15 29 -33 58 -39 65 -12
14 -47 72 -84 140 -14 26 -29 47 -34 47 -5 0 -11 10 -15 23 -3 13 -21 43 -41
68 -19 24 -35 48 -35 53 0 4 -10 21 -22 36 -32 40 -78 104 -91 127 -20 34 -89
138 -96 143 -3 3 -12 17 -20 33 -8 15 -18 27 -23 27 -4 0 -19 17 -32 38 -13
21 -41 59 -63 84 -21 25 -54 66 -73 92 -19 25 -48 61 -65 79 -16 18 -41 48
-55 66 -14 18 -37 45 -52 59 -16 15 -28 31 -28 36 0 6 -13 24 -29 40 -17 17
-58 62 -93 100 -69 76 -143 151 -204 207 -21 20 -46 45 -55 55 -17 20 -237
228 -279 264 -55 47 -134 116 -161 140 -31 29 -81 69 -124 102 -39 30 -47 36
-129 102 -38 31 -72 56 -75 56 -4 0 -16 8 -27 18 -10 10 -35 29 -54 42 -19 13
-44 32 -54 42 -11 10 -23 18 -27 18 -5 0 -16 9 -26 19 -17 18 -32 28 -112 76
-18 11 -45 29 -60 41 -14 11 -45 31 -68 44 -24 13 -43 27 -43 31 0 4 -11 10
-25 13 -14 4 -34 15 -45 26 -11 11 -41 31 -67 45 -26 14 -70 40 -98 57 -81 51
-127 77 -185 104 -30 14 -57 29 -60 34 -3 4 -23 16 -45 27 -125 62 -170 87
-182 98 -7 8 -27 17 -45 20 -18 4 -58 20 -88 35 -86 44 -169 80 -183 80 -7 0
-30 12 -51 26 -21 15 -61 32 -88 40 -28 7 -57 19 -67 27 -23 21 -111 38 -117
23z"/>
<path d="M12835 19891 c-77 -13 -151 -46 -220 -98 -100 -76 -175 -228 -175
-355 0 -199 130 -372 332 -443 48 -16 246 -21 276 -6 9 4 42 20 72 34 66 30
160 97 160 115 0 6 5 12 10 12 6 0 10 6 10 14 0 7 6 19 14 25 36 30 89 199 81
260 -6 42 -25 124 -34 146 -33 77 -45 96 -106 160 -61 64 -162 120 -235 131
-65 9 -143 11 -185 5z"/>
<path d="M8728 5080 c-174 -30 -262 -181 -186 -320 31 -56 83 -84 267 -141
112 -36 154 -87 120 -151 -38 -71 -225 -60 -342 20 -25 18 -51 32 -57 32 -6 0
-23 -26 -37 -57 l-26 -56 27 -22 c42 -33 145 -81 204 -95 163 -38 339 25 388
139 19 45 18 134 -2 174 -35 67 -84 97 -244 148 -124 40 -160 66 -160 114 0
92 131 109 288 39 29 -13 56 -24 60 -24 8 0 62 104 62 119 0 16 -116 64 -189
77 -84 15 -105 15 -173 4z"/>
<path d="M12715 5079 c-113 -19 -214 -85 -277 -181 -45 -69 -58 -118 -58 -216
0 -136 52 -241 158 -318 109 -80 261 -105 388 -64 152 49 255 161 284 308 44
223 -102 429 -334 471 -67 12 -89 12 -161 0z m200 -150 c120 -56 183 -206 137
-325 -29 -79 -67 -120 -138 -155 -58 -29 -71 -31 -132 -27 -37 3 -82 13 -101
22 -189 98 -204 356 -29 470 75 49 178 55 263 15z"/>
<path d="M19445 5073 c-163 -59 -261 -173 -286 -334 -13 -82 0 -154 41 -242
20 -42 113 -147 130 -147 5 0 15 -6 22 -13 7 -8 41 -24 76 -35 131 -46 315
-20 435 61 l27 18 0 175 0 174 -155 0 -156 0 3 -62 3 -63 85 -5 85 -5 3 -65 3
-66 -46 -22 c-51 -25 -137 -38 -188 -28 -58 11 -152 79 -184 133 -25 43 -28
57 -28 138 0 80 3 95 27 137 91 153 273 181 441 65 16 -10 23 -6 57 33 22 25
40 50 40 56 0 15 -61 54 -130 84 -76 32 -232 39 -305 13z"/>
<path d="M5740 5078 c0 -2 -1 -178 -1 -393 l0 -390 296 -3 296 -2 -3 62 -3 63
-220 5 -220 5 0 95 0 95 193 3 192 2 0 65 0 65 -192 2 -193 3 0 95 0 95 218 3
217 2 0 65 0 65 -290 0 c-159 0 -290 -1 -290 -2z"/>
<path d="M7255 4878 c-49 -112 -101 -230 -116 -263 -64 -143 -139 -316 -139
-321 0 -3 34 -4 77 -2 l76 3 31 75 32 75 197 3 198 2 25 -57 c47 -111 38 -103
126 -103 43 0 78 2 78 5 0 3 -4 13 -10 23 -5 9 -35 76 -66 147 -31 72 -62 144
-69 160 -8 17 -50 113 -93 215 -44 102 -85 197 -92 213 -13 26 -16 27 -90 27
l-76 0 -89 -202z m235 -130 c34 -81 59 -152 55 -158 -8 -13 -252 -14 -260 -1
-7 13 127 324 136 314 3 -5 34 -74 69 -155z"/>
<path d="M9780 5075 c0 -9 60 -126 85 -165 12 -19 47 -82 78 -140 31 -58 72
-134 91 -170 35 -64 36 -66 36 -187 l0 -123 75 0 75 0 0 130 c0 117 2 133 24
172 82 150 246 456 252 471 6 16 0 18 -67 15 l-73 -3 -72 -125 c-40 -69 -73
-130 -73 -137 -1 -6 -4 -13 -8 -15 -5 -1 -18 -21 -30 -43 -12 -22 -25 -41 -30
-42 -5 -2 -48 65 -95 149 -138 242 -116 218 -198 218 -38 0 -70 -2 -70 -5z"/>
<path d="M11230 4685 l0 -395 245 0 246 0 -3 68 -3 67 -165 2 -165 2 -5 323
-5 323 -72 3 -73 3 0 -396z"/>
<path d="M14157 4998 c-20 -46 -73 -166 -117 -268 -45 -102 -90 -203 -100
-225 -25 -53 -90 -206 -90 -211 0 -3 34 -4 77 -2 l76 3 31 75 32 75 199 0 199
0 32 -75 31 -75 81 -3 81 -3 -24 60 c-14 33 -38 89 -55 126 -16 36 -30 68 -30
71 0 3 -11 29 -24 57 -14 29 -65 147 -115 262 l-90 210 -79 3 -79 3 -36 -83z
m181 -248 c35 -82 61 -154 58 -159 -8 -13 -253 -14 -261 -1 -3 5 12 50 34 100
23 49 41 92 41 94 0 12 51 116 57 116 5 0 36 -67 71 -150z"/>
<path d="M15400 5048 c-1 -18 -1 -195 -1 -393 l-1 -360 184 -3 c199 -4 261 5
344 44 231 112 284 444 99 626 -36 36 -99 75 -150 94 -40 14 -90 18 -262 22
l-213 4 0 -34z m406 -113 c111 -33 174 -125 174 -255 0 -66 -4 -82 -34 -135
-28 -52 -41 -64 -96 -93 -62 -32 -64 -33 -184 -30 l-121 3 -3 250 c-1 137 0
255 3 262 7 19 197 17 261 -2z"/>
<path d="M17720 4685 l0 -395 70 0 70 0 0 260 c0 161 4 260 10 260 5 0 51 -55
102 -122 50 -67 97 -129 104 -138 7 -8 34 -44 61 -80 26 -36 50 -67 53 -70 3
-3 17 -21 30 -40 49 -70 49 -70 127 -70 l73 0 -2 393 -3 392 -70 0 -70 0 -5
-270 -5 -269 -149 199 c-82 110 -174 233 -204 273 l-54 72 -69 0 -69 0 0 -395z"/>
<path d="M16826 4419 c-20 -16 -26 -29 -26 -59 0 -30 6 -43 26 -59 54 -43 124
-10 124 58 0 70 -68 104 -124 60z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
